import { useEffect, useState } from 'react';
import { DEFAULT_MAX_PACING_RATIO, resolveMaxPacingRatioForSave } from '@/utilities/campaignPacingAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaPhoneAlt,
} from '@/features/acl-settings/aclSettingsUi';

type Props = {
  show: boolean;
  onHide: () => void;
  initialMax?: string;
  grantableRatios: string[];
  limitedByParent?: boolean;
  showChildNote?: boolean;
  onSave: (max: string) => void;
};

const PacingRatiosAclModal = ({
  show,
  onHide,
  initialMax,
  grantableRatios,
  limitedByParent = false,
  showChildNote = false,
  onSave,
}: Props) => {
  const [selected, setSelected] = useState('');

  useEffect(() => {
    if (!show) return;
    setSelected(resolveMaxPacingRatioForSave(initialMax, grantableRatios));
  }, [show, initialMax, grantableRatios]);

  const handleSave = () => {
    onSave(selected);
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Campaigns — Power Dialer Max Pacing Ratio"
      icon={FaPhoneAlt}
      description={
        'Select the highest pacing ratio allowed. Power Dialer campaigns can use any ratio from 1:1 up to this. Changes apply to new campaigns only.' +
        (showChildNote
          ? ' You cannot set it lower than what ACLs created under this one already allow; lower theirs first.'
          : '')
      }
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={() => setSelected(resolveMaxPacingRatioForSave(null, grantableRatios))}
      saveDisabled={!selected}
    >
      <AclModalSection icon={FaPhoneAlt} title="Max Pacing Ratio" subtitle="">
        {grantableRatios.map((ratio) => (
          <AclModalOptionCheck
            key={ratio}
            id={`pacing-ratio-${ratio.replace(':', '-')}`}
            label={ratio}
            description={ratio === DEFAULT_MAX_PACING_RATIO ? 'Default' : undefined}
            checked={ratio === selected}
            onChange={() => setSelected(ratio)}
          />
        ))}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default PacingRatiosAclModal;
